import { MATERIAL } from 'Pods/ThreeDStudio/Store/constants'

/**
 * Resolves the material setting from the run's PBR/geometry flags.
 * Geometry-only takes precedence over PBR; both falsy means BASIC.
 *
 * @param {boolean} [enablePbr] - Whether the run was generated with PBR enabled
 * @param {boolean} [enableGeometry] - Whether the run was generated as geometry-only
 * @returns {string} - One of MATERIAL.GEOMETRY_ONLY | MATERIAL.PBR | MATERIAL.BASIC
 */
export const deriveMaterial = (enablePbr, enableGeometry) => {
  if (enableGeometry) {
    return MATERIAL.GEOMETRY_ONLY
  }

  if (enablePbr) {
    return MATERIAL.PBR
  }

  return MATERIAL.BASIC
}
